import { render } from "./CadastroModelosContratosView.vue?vue&type=template&id=fc907ab8&scoped=true"
import script from "./CadastroModelosContratosView.vue?vue&type=script&lang=js"
export * from "./CadastroModelosContratosView.vue?vue&type=script&lang=js"

import "./CadastroModelosContratosView.vue?vue&type=style&index=0&id=fc907ab8&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc907ab8"]])

export default __exports__